import { ECOSYSTEM_PROFILES } from './data/ecosystemProfiles.js';
import { organismStates } from './organismStates.js';


export const organismProfiles = ECOSYSTEM_PROFILES;


function getScore(current, ideal) {
  const { min, max } = ideal;
  if (current >= min && current <= max) return 1;
  const range = max - min;
  const diff = Math.min(Math.abs(current - min), Math.abs(current - max));
  return Math.max(0, 1 - diff / range);
}

export function updateVitalStats(name, sensorData) {
  console.log('Updating vital stats for:', name, sensorData);
  const profile = organismProfiles[name];
  const state = organismStates[name];

  if (!profile || !state) return;

  const ideal = profile.idealParams;
  const scores = [];

  if (sensorData.temperature)
    scores.push(getScore(sensorData.temperature, ideal.temperature));
  if (sensorData.foodAmount)
    scores.push(getScore(sensorData.foodAmount, ideal.foodAmount));
  if (sensorData.light)
    scores.push(getScore(sensorData.light, ideal.light));

  const avgScore = scores.reduce((a, b) => a + b, 0) / scores.length;

  // Update values
  state.health = Math.round(avgScore * 100);
  state.vitality = Math.round(avgScore * 10);
  state.growthRate = parseFloat((avgScore * 1.5).toFixed(2));  // cm/month
}
